module.exports = __webpack_public_path__ + "static/media/texture-season-7.75e80156.jpg";